import React, { useCallback, useEffect } from 'react';
import type { SupportedAlohaHeaderPhotoLayoutSchema } from '@shared/types/WebsiteHeaderSettings.types';
import { AlohaPhotoSlider } from '@apps/guest/packages/layout-engine/widgets/Custom/components';
import { Photo } from '../Photo/Photo';
import { isInIframe } from '@shared/utils/isInIframe';
import { sendMessageToParentWindow } from '@shared/utils/previewMessageBus';

interface HeaderPhotoProps {
  headerPhoto?: SupportedAlohaHeaderPhotoLayoutSchema;
}

const isPreview = isInIframe();

export const HeaderPhoto = ({ headerPhoto }: HeaderPhotoProps) => {
  const showPlaceholder = isPreview && !!headerPhoto?.presentationLayout;

  useEffect(() => {
    if (headerPhoto?.presentationLayout) {
      sendMessageToParentWindow({ action: 'requestIframeScaleValue', source: 'joyPreview' });
    }
  }, [headerPhoto?.presentationLayout]);

  const getHeaderPhotoComponent = useCallback(() => {
    if (!headerPhoto) {
      return null;
    }

    switch (headerPhoto.presentationLayout) {
      case 'center':
        return (
          <Photo
            {...headerPhoto?.photos?.[0]}
            showPlaceholder={showPlaceholder}
          />
        );
      case 'photoSlider':
        return (
          <AlohaPhotoSlider
            photos={headerPhoto?.photos?.map(photo => ({ ...photo, id: photo.id, photoUrl: photo.url })) || []}
            photoHeight="100vh"
            showPlaceholder={showPlaceholder}
          />
        );
      default:
        return null;
    }
  }, [headerPhoto, showPlaceholder]);

  return getHeaderPhotoComponent();
};
